const DEPLOYED_BACKEND_URL =
  process.env.REACT_APP_DEPLOYED_BACKEND_URL ||
  "https://neuracraft-backend-983400771183-983400771183.us-central1.run.app";

const rawApiBaseUrl =
  process.env.REACT_APP_BACKEND_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  (typeof window !== "undefined" &&
  window.location?.hostname &&
  !["localhost", "127.0.0.1", "0.0.0.0"].includes(window.location.hostname)
    ? DEPLOYED_BACKEND_URL
    : "http://localhost:8000");

const hasApiPath = (value) => {
  try {
    const { pathname } = new URL(value);
    return /\/api(\/|$)/.test(pathname);
  } catch (_error) {
    return /\/api(\/|$)/.test(value);
  }
};

const ensureUrl = (value) => {
  if (!value) return "";
  try {
    // Already a full URL
    new URL(value);
    return value;
  } catch (_err) {
    // Try https first, then http (useful for bare domains)
    try {
      new URL(`https://${value}`);
      return `https://${value}`;
    } catch (_err2) {
      try {
        new URL(`http://${value}`);
        return `http://${value}`;
      } catch (_err3) {
        return value;
      }
    }
  }
};

// Normalize trailing slashes and ensure we point to the API root
const normalizedBase = ensureUrl(rawApiBaseUrl).replace(/\/+$/, "");
const apiAlreadyIncluded = hasApiPath(normalizedBase);

export const API_BASE_URL = apiAlreadyIncluded
  ? normalizedBase
  : `${normalizedBase}`;

export default API_BASE_URL;
